import type { FC } from 'react';
import type { ActiveSection } from 'src/components/layout/header/types';
import { Link } from 'src/components/navigation/link';

export const isMarketMessagesActive = (pathname: string) =>
  pathname.startsWith('/market-messages');

export const SecondaryNavMarketMessages: FC<{
  activeSection: ActiveSection;
}> = ({ activeSection }) => {
  if (!activeSection.marketMessages) return null;

  return (
    <div
      className={`
        flex flex-col flex-wrap items-stretch gap-x-xl gap-y-md
        md:flex-row md:items-center
        legacy:gap-x-[2rem] legacy:gap-y-[1rem]
      `}
      data-testid="secondary-nav"
    >
      <Link
        mode="secondary"
        to="/market-messages/urgent-market-messages"
        data-help-annotation="umm-overview:2 umm-rss:2"
      >
        Urgent Market Messages
      </Link>

      <Link mode="secondary" to="/market-messages/maintenance-messages">
        Maintenance Messages
      </Link>
    </div>
  );
};
